<template>
    <painel-component :itens="itemsOne">
        <form>
            <row-component>
                <row-col-component class-row-col="col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
                    <label>Nome:</label>
                    <input-component v-model="formData.name" type-input="text"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
                    <label>Status:</label>
                    <Multiselect v-model="formData.status" :options="selectActiveInative" :searchable="true"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 mt-4">
                    <button-submit class="me-2" @submit="submit" :items="itemsTwo"/>
                    <button-route v-if="buttonCheck.create" :items="itemsRoute"/>
                </row-col-component>
            </row-component>
        </form>

        <table class="table table-striped">
            <thead>
            <tr>
                <th scope="col" style="width: 40%">Nome</th>
                <th scope="col" style="width: 40%">Status</th>
                <th scope="col" style="width: 20%" v-if="buttonCheck.show ||buttonCheck.edit || buttonCheck.delete">
                    Ações
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(data, index) in object.data" :key="index">
                <td data-label="Nome">{{ data.name }}</td>
                <td data-label="Status">{{ statusString(data.status) }}</td>
                <td data-label="Ações" v-if="buttonCheck.show ||buttonCheck.edit || buttonCheck.delete">
                    <button-show v-if="buttonCheck.show" :route="'guest-schedule-show'" :id-param="data.id"/>
                    <button-edit v-if="buttonCheck.edit" :route="'guest-schedule-edit'" :id-param="data.id"/>
                    <button-delete v-if="buttonCheck.delete" @click="destroyUser(data)"/>
                </td>
            </tr>
            </tbody>
        </table>

        <button-pagination :pagination="object" :offset="3" @paginate="loadItems"/>
    </painel-component>
</template>

<script>
import PainelComponent from "@/components/dashboard/PainelComponent";
import RowComponent from "@/components/row/RowComponent";
import RowColComponent from "@/components/row/RowColComponent";
import InputComponent from "@/components/form/InputComponent";
import Multiselect from "@vueform/multiselect";
import ButtonSubmit from "@/components/buttons/ButtonSubmit";
import ButtonRoute from "@/components/buttons/ButtonRoute";
import ButtonShow from "@/components/buttons/ButtonShow";
import ButtonEdit from "@/components/buttons/ButtonEdit";
import ButtonDelete from "@/components/buttons/ButtonDelete";
import ButtonPagination from "@/components/buttons/ButtonPagination";

import {useToast} from "vue-toastification";
import swal from "sweetalert";

const toast = useToast()
export default {
    name: "GuestScheduleSearch",
    components: {
        ButtonPagination,
        ButtonDelete,
        ButtonEdit,
        ButtonShow,
        ButtonRoute,
        ButtonSubmit,
        Multiselect,
        InputComponent,
        RowColComponent,
        RowComponent,
        PainelComponent
    },

    created() {
        this.$store.dispatch("updateNamePage", "Convidado Agenda")
        this.loadItems(1)
        this.checkACL()
    },

    data() {
        return {
            itemsOne: {
                title: "Pesquisa",
                icon: "ti-list"
            },

            itemsTwo: {
                icon: "ti-search",
                typeButton: "button"
            },

            itemsRoute: {
                route: "/guest-schedule/create",
                icon: "ti-plus"
            },

            buttonCheck: {
                create: false,
                show: false,
                edit: false,
                delete: false,
            },

            formData: {
                name: "",
                status: ""
            },

            searchSubmit: false,
        }
    },

    methods: {
        submit() {
            this.loadItems(1)
            this.searchSubmit = true
        },

        loadItems(page) {
            if (!this.searchSubmit) {
                this.$store.dispatch('loadGuestSchedules', {...this.params, page})
                    .then((r) => {
                        if (this.searchSubmit) {
                            this.searchSubmit = false;
                            if (r.data.length === 0) {
                                toast.info("Nada foi encontrado com os parâmetros informados!", {timeout: 2000});
                            }
                        }
                    }).catch(() => {
                    this.searchSubmit = false;
                });
            }
        },

        destroyUser(item) {
            swal({
                title: 'Atenção!',
                text: `Deseja realmente deletar ${item.name} ?`,
                closeOnClickOutside: false,
                buttons: {
                    cancel: {
                        text: 'Não',
                        visible: true,
                        closeModal: true,

                    },
                    confirm: "Sim"
                }
            }).then((result) => {
                if (result) {
                    this.$store.dispatch('destroyGuestSchedule', item.id).then(() => {
                        this.loadItems(1)
                        toast.success('Cadastro deletado com sucesso', {timeout: 2000});
                    }).catch(() => {
                        toast.error(`Não foi possível deletar  ${item.name} `, {timeout: 2000});
                    })
                }
            });
        },

        async checkACL() {
            this.$store.dispatch('ACLitens', 21)
                .then((r) => {
                    if (r.data.indexOf('guest-schedule-search') !== -1) {

                        if (r.data.indexOf('guest-schedule-create') !== -1) {
                            this.buttonCheck.create = true
                        }
                        if (r.data.indexOf('guest-schedule-search') !== -1) {
                            this.buttonCheck.show = true
                        }
                        if (r.data.indexOf('guest-schedule-edit') !== -1) {
                            this.buttonCheck.edit = true
                        }
                        if (r.data.indexOf('guest-schedule-delete') !== -1) {
                            this.buttonCheck.delete = true
                        }
                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

        statusString(value) {
            if (parseInt(value) === 1)
                return 'Ativo'
            return 'Inativo'
        },
    },

    computed: {
        noOptionsText() {
            return this.$store.state.var.noOptionsText
        },

        noResultsText() {
            return this.$store.state.var.noResultsText
        },

        selectActiveInative() {
            return this.$store.state.var.selectActiveInative
        },

        object() {
            return this.$store.state.guest_schedule.items
        },

        params() {
            return {
                page: this.object.current_page,
                name: this.formData.name,
                status: this.formData.status,
            }
        }
    }
}
</script>